export const send_input_request = 'send_input_request'
export const send_input_success = 'send_input_success'
export const send_input_failure = 'send_input_failure'
export const send_table_off = 'send_table_off'
export const send_table_on = 'send_table_on'
